module.exports = __webpack_public_path__ + "img/main_menu_5.62a7e680.png";